import {
	renderAirportLocationLink,
	renderContinentLink,
	renderCountryLink,
	renderDefault,
	renderOperatorLink,
} from "../search/result/renderers";

export const columns = [
	{
		key: "airline",
		label: "Operator Name",
		render: renderOperatorLink,
	},
	{
		key: "iata_code",
		label: "IATA",
		render: renderDefault,
	},
	{
		key: "icao_code",
		label: "IATA",
		render: renderDefault,
	},
	{
		key: "location_airport",
		label: "Location",
		render: renderAirportLocationLink,
	},
	{
		key: "continent",
		label: "Continent",
		render: renderContinentLink,
	},
	{
		key: "country",
		label: "Country",
		render: renderCountryLink,
	},
	{
		key: "airline_type_description",
		label: "Type",
		render: renderDefault,
	},
	{
		key: "status",
		label: "Status",
		render: renderDefault,
	},
	{
		key: "airline_default",
		label: "Operator Default",
		render: null,
	},
];
